/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type FavoriteSellerInput = {
    readonly sellerPk: string;
    readonly userId: string;
    readonly favoriteId?: string | null;
    readonly clientMutationId?: string | null;
};
export type storefrontFollowDealerMutationVariables = {
    readonly input: FavoriteSellerInput;
    readonly userId: string;
};
export type storefrontFollowDealerMutationResponse = {
    readonly favoriteSeller: {
        readonly seller: {
            readonly favoritesByUser: ReadonlyArray<{
                readonly serviceId: string | null;
            } | null> | null;
        } | null;
    } | null;
};
export type storefrontFollowDealerMutation = {
    readonly response: storefrontFollowDealerMutationResponse;
    readonly variables: storefrontFollowDealerMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "FavoriteSellerInput!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = [
        ({
            "kind": "Variable",
            "name": "userIds",
            "variableName": "userId"
        } as any)
    ], v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "storefrontFollowDealerMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "favoriteSeller",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "FavoriteSellerPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "seller",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Seller",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "favoritesByUser",
                                    "storageKey": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "Favorite",
                                    "plural": true,
                                    "selections": [
                                        (v3 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "storefrontFollowDealerMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "favoriteSeller",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "FavoriteSellerPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "seller",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Seller",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "favoritesByUser",
                                    "storageKey": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "Favorite",
                                    "plural": true,
                                    "selections": [
                                        (v3 /*: any*/),
                                        (v4 /*: any*/)
                                    ]
                                },
                                (v4 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "storefrontFollowDealerMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/storefrontFollowDealerMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '912a25bb1043faea3e9f3a5e5b7f9791';
export default node;
